import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import moment from 'moment';

// Action Creators using redux-act
export const FETCH_SESSIONS_INIT = createAction('FETCH_SESSIONS_INIT');
export const FETCH_SESSIONS_SUCCESS = createAction('FETCH_SESSIONS_SUCCESS');
export const FETCH_SESSIONS_FAIL = createAction('FETCH_SESSIONS_FAIL');
export const FETCH_SESSION_DETAILS_INIT = createAction('FETCH_SESSION_DETAILS_INIT');
export const FETCH_SESSION_DETAILS_SUCCESS = createAction('FETCH_SESSION_DETAILS_SUCCESS');
export const FETCH_SESSION_DETAILS_FAIL = createAction('FETCH_SESSION_DETAILS_FAIL');
export const FETCH_SESSIONS_LIST_INIT = createAction('FETCH_SESSIONS_LIST_INIT');
export const FETCH_SESSIONS_LIST_SUCCESS = createAction('FETCH_SESSIONS_LIST_SUCCESS');
export const FETCH_SESSIONS_LIST_FAIL = createAction('FETCH_SESSIONS_LIST_FAIL');
export const CLEAR_SESSIONS_DATA = createAction('CLEAR_SESSIONS_DATA');
export const EXPORT_SESSIONS_INIT = createAction('EXPORT_SESSIONS_INIT');
export const EXPORT_SESSIONS_SUCCESS = createAction('EXPORT_SESSIONS_SUCCESS');
export const EXPORT_SESSIONS_FAIL = createAction('EXPORT_SESSIONS_FAIL');


export const fetchSessionAnalytics = (params = {}) => {
  return async (dispatch) => {
    dispatch(FETCH_SESSIONS_INIT());
    
    try {
      const response = await Axios.get(`${url}/data/getAll`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      // Dispatch success with the analytics data structure
      dispatch(FETCH_SESSIONS_SUCCESS({ 
        analytics: response.data.data,
        message: response.data.message 
      }));
      
    } catch (error) {
      toastr.error('Error: Failed to fetch session analytics');
      return dispatch(FETCH_SESSIONS_FAIL({ error }));
    }
    
    return null;
  };
};

export const fetchSessionDetails = (sessionId) => {
  return async (dispatch) => {
    dispatch(FETCH_SESSION_DETAILS_INIT());
    try {
      const response = await Axios.get(`${url}/data/${sessionId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      // Use the action creator, not a plain object
      dispatch(FETCH_SESSION_DETAILS_SUCCESS({
        session: response.data.data
      }));

    } catch (error) {
      toastr.error('Error', 'Failed to fetch session details');
      dispatch(FETCH_SESSION_DETAILS_FAIL({ error })); // Call the action creator
    }
  };
};

export const fetchSessionsList = (params = {}) => {
  return async (dispatch) => {
    dispatch(FETCH_SESSIONS_LIST_INIT());
    try {
      const response = await Axios.get(`${url}/data/list`, {
        params,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
      dispatch(FETCH_SESSIONS_LIST_SUCCESS(response.data.data));
    } catch (error) {
      toastr.error('Error', 'Failed to fetch sessions list');
      dispatch(FETCH_SESSIONS_LIST_FAIL({ error }));
    }
  };
};

export const exportSessionsByFilter = (filter) => {
  return async (dispatch) => {
    dispatch(EXPORT_SESSIONS_INIT());
    toastr.info('Exporting...', 'Your CSV file is being generated.');
    try {
      const response = await Axios.post(
        `${url}/data/by-filter`,
        filter,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = `export-by-filter-${moment().format('YYYY-MM-DD')}.csv`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      dispatch(EXPORT_SESSIONS_SUCCESS());
      toastr.success('Success', 'Your file has been downloaded.');
    } catch (error) {
      dispatch(EXPORT_SESSIONS_FAIL({ error }));
      toastr.error('Export Failed', 'Could not generate the CSV file.');
    }
  };
};
export const exportSessionsById = (sessionIds) => {
  return async (dispatch) => {
    dispatch(EXPORT_SESSIONS_INIT());
    toastr.info('Exporting...', 'Your CSV file is being generated.');
    try {
      const response = await Axios.post(`${url}/data/by-id`, { sessionIds }, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const fileName = `export-by-id-${moment().format('YYYY-MM-DD')}.csv`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      dispatch(EXPORT_SESSIONS_SUCCESS());
      toastr.success('Success', 'Your file has been downloaded.');
    } catch (error) {
      dispatch(EXPORT_SESSIONS_FAIL({ error }));
      toastr.error('Export Failed', 'Could not generate the CSV file.');
    }
  };
};

/**
 * Action to clear the session data from the Redux store.
 */
export const clearSessions = () => {
    return (dispatch) => {
        dispatch(CLEAR_SESSIONS_DATA());
    };
};
